import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
query getSalesGroup($id: ID!) {
	cashAssist {
		getSalesGroup(id: $id) {
			...salesGroupMain
		}
	}
}
${main}`
